import React from 'react';
// Lucide React 직접 import - Vite 번들링 최적화 및 초기화 순서 문제 해결
import { Bookmark } from 'lucide-react';
import { Button } from '@edusense/shared-ui-kit';
import { ActionGroup, BookmarkSection } from '../SocialActions.styles';
import { getButtonSize } from '../utils';
export var BookmarkButton = function(param) {
    var bookmarked = param.bookmarked, variant = param.variant, onBookmark = param.onBookmark, size = param.size, labels = param.labels;
    var buttonContent = /*#__PURE__*/ React.createElement(Bookmark, {
        className: bookmarked ? "fill-current" : "",
        strokeWidth: bookmarked ? 2.5 : 2,
        fill: bookmarked ? "currentColor" : "none"
    });
    var buttonClassName = "border-0 ".concat(bookmarked ? "text-blue-500 dark:text-blue-400" : "text-gray-500 hover:text-blue-500 dark:text-gray-300 dark:hover:text-blue-400");
    var handleClick = function(e) {
        e.stopPropagation();
        e.preventDefault();
        onBookmark(e);
    };
    if (variant !== 'spaced') {
        return /*#__PURE__*/ React.createElement(ActionGroup, null, /*#__PURE__*/ React.createElement(Button, {
            iconOnly: true,
            size: getButtonSize(size),
            variant: "ghost",
            icon: buttonContent,
            onClick: handleClick,
            label: labels.bookmark || '저장',
            className: buttonClassName,
            animation: "none"
        }));
    }
    return /*#__PURE__*/ React.createElement(BookmarkSection, null, /*#__PURE__*/ React.createElement(Button, {
        size: getButtonSize(size),
        variant: "ghost",
        leftIcon: buttonContent,
        onClick: handleClick,
        label: labels.bookmark || '저장',
        className: buttonClassName
    }, labels.bookmark || '저장'));
};
